<template>
  <v-app id="inspire" :class="{ horizontalstyle: setHorizontalLayout }">
    <VerticalHeader v-model="expandOnHover"></VerticalHeader>
    <v-main>
      <v-container fluid class="page-wrapper">
        <router-view />
      </v-container>
    </v-main>
    <VerticalSidebar :expand-on-hover.sync="expandOnHover"></VerticalSidebar>
    <Footer></Footer>
  </v-app>
</template>

<script>
import VerticalHeader from "./vertical-header/VerticalHeader";
import VerticalSidebar from "./vertical-sidebar/VerticalSidebar";
import Footer from "./footer/Footer";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Layout",

  components: {
    VerticalHeader,
    VerticalSidebar,
    Footer

    // Customizer
  },

  props: {
    source: String
  },
  data: () => ({
    expandOnHover: false
  }),
  computed: {
    ...mapState(["Customizer_drawer", "setHorizontalLayout"])
  },

  methods: {
    ...mapMutations({
      setCustomizerDrawer: "SET_CUSTOMIZER_DRAWER"
    })
  }
};
</script>
